import {IHttpService} from "angular";
import {Expiries} from "./Expiries";
import {IsoDate} from "../../pseudo-types/DateTypes";

export class ExpiryService {

    public static id = "expiryService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async get(market: string): Promise<Expiries> {
        const response = await this.$http.get<Array<ExpiryData>>(`/tradefloor/api/market/${market}/expiries`);
        const expiries = response.data!.map(e => new Expiry(e.date, e.index, e.equity, e.expiryType));

        return new Expiries(expiries);
    }
}

export type ExpiryType = "WEEKLY" | "MONTHLY" | "QUARTERLY";

export interface ExpiryData {
    date: IsoDate;
    index: boolean;
    equity: boolean;
    expiryType: ExpiryType;
}

export class Expiry {
    public constructor(public readonly date: IsoDate,
                       public readonly index: boolean,
                       public readonly equity: boolean,
                       public readonly expiryType: ExpiryType) {
    }
}
